/* (ignored) */


//////////////////
// WEBPACK FOOTER
// stream (ignored)
// module id = 2
// module chunks = main